export enum DealerClaimType {
  DiegoExtendedCreditCheckResultFunctionality = 'DiegoExtendedCreditCheckResult',
  DiegoContactSigningBypassFunctionality = 'DiegoContractSigningBypass',
  DiegoVoiceFunctionality = 'DiegoVoiceFunctionality',
  DiegoHardwareFunctionality = 'DiegoHardwareFunctionality',
  DiegoMbbFunctionality = 'DiegoMbbFunctionality',
  DiegoSecretCustomerInformation = 'DiegoSecretCustomerInformation',
  IdentificationWithPhysicalDoc = 'IdentificationWithPhysicalDoc',
  IdentificationQuestions = 'IdentificationQuestions',
  ContractSigningPaper = 'ContractSigningPaper',
  ContractSigningDigital = 'ContractSigningDigital',
  ContractSigningSMS = 'ContractSigningSMS',
  CanSellMobilePhone = 'CanSellMobilePhone',
  CanSellHardwareWithLogistics = 'CanSellHardwareWithLogistics',
  CanSellMBBSubscriptionOnly = 'CanSellMBBSubscriptionOnly',
  CanSeeAllOrders = 'CanSeeAllOrdersInDiego',
  CanAdministerSellers = 'CanAdministerSellersInDiego',
  EquipmentUpgrade = 'EquipmentUpgrade',
  CanOrderBulkSim = 'CanOrderBulkSimInDiego',
  CanReplaceMobilbyttePhone = 'CanReplaceMobilbyttePhone',
  AccessoryKit = 'AccessoryKit',
  CanSellCellPhoneWithSubscription = 'CanSellCellPhoneWithSubscription',
  CanSellMobileInsurance = 'CanSellMobileInsurance',
  CanSellCellPhoneWithoutSubscription = 'CanSellCellPhoneWithoutSubscription',
  CanCreateCustomerOnly = 'CanCreateCustomerOnly',
  CanSellTradeIn = 'CanSellTradeIn',
  RetailPayment = 'RetailPayment',
  AllowManualPhoneRegistration = 'AllowManualPhoneRegistration',
  CanUpdateImei = 'CanUpdateImei',
  CanUseBankIdForIdentification = 'CanUseBankIdForIdentification',
  CanBypassBankId = 'CanBypassBankId',
  CanUseCampaignVouchers = 'CanUseCampaignVouchers',
  CanRegisterEid = 'CanRegisterEid',
  CanUseSalesCompetition = 'CanUseSalesCompetition',
}
